<ion-app class="scanner-hide">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
